import { listConstants } from "../constants"
const initialState = {
  categoryList: [],
}

export function list(state = initialState, action) {
  switch (action.type) {
    case listConstants.INIT_LIST_CONSTANT: {
      return initialState
    }
    case listConstants.GET_CAMPAIGN_CATEGORY_LIST: {
      return {
        ...state,
        categoryList: action.data,
      }
    }
    default:
      return state
  }
}
